export default "__VITE_ASSET__83a6c6d9__"